import renderTemplate from '@frontend/util/template';
import { toKebabCase, capitalizeEveryWord } from '@frontend/util/text';
import { getParams, updateQueryString } from '@frontend/util/url';
import $ from 'jquery';
import {
  getBaseURL,
  getCurrentNavigationTab,
  getNavigationTabFromSection,
  fullUrl,
  pageExists,
  getRegionLanguageSection
} from './utils';
import breadcrumbsTemplate from './views/breadcrumbs.tpl.html';
import categoryTemplate from './views/category.tpl.html';
import paginationTemplate from './views/pagination.tpl.html';

const knowledeArticleRe = /\/[a-z]{2}\/(?:[a-z]{2}\/)*knowledge\//i;
const pageSize = 9;
const pageLanguage = getRegionLanguageSection(location.pathname).language;

const allLookup = {
  en: 'all',
  fr: 'tous',
  es: 'todo',
  de: 'alles',
  nl: 'alle'
};

/**
 * Need to fake the regions section when accessing /xx/yy/knowledge/* or
 * /yy/knowledge/*, and certain contact pages (links in hero)
 * this is done with a ?section=xyz querystring parameter which we use to get
 * the associated middle-nav tab which as a data-theme attribute.
 * 2 steps, 1 = update the urls that should be to include the section param, 2 =
 * on page load applay the correct theme and select the right tab
 * - if no body class try to figure it out
 *  - get tab from section param
 *   - no param = use first tab
 *   - else get current matching tab tokebabcase of text should match section param
 *  - get theme from tab
 *  - set tab as active
 */
const selectTab = () => {
  const validThemes = Array.from($('.middle-nav-links .nav-item')).map(el => $(el).attr('data-theme'));
  if ($('body').is(validThemes.map(theme => `.theme-${theme}`).join(', '))) {
    return;
  }
  const tab = getNavigationTabFromSection(false);
  tab.find('a').addClass('active');
  $('body').addClass(`theme-${tab.attr('data-theme')}`);
};

/**
 * update links that only match one of these patterns
 * /xx/yy/knowledge/ or /yy/knowledge/
 * /na/en/knowledge/ or /en/knowledge/
 */
const initLinks = () => {
  const tab = getCurrentNavigationTab();
  if (tab && tab.length) {
    const section = tab.attr('data-section');
    $('a[href*="/knowledge/"]').each((i, el) => {
      const link = $(el);
      const href = link.attr('href');
      if (knowledeArticleRe.test(href)) {
        const qs = updateQueryString({ section }, link.get(0));
        link.attr('href', `${href}?${qs}`);
      }
    });
  }
};

/**
 * Update Hero and bottom promo links to point to "section"
 * versions if they exist on knowledge article pages. Falls
 * back to generic version if that exists.
 *
 * Assumes naming conventions
 *  /na/en/somepage.html (original)
 *  /na/en/providers/somepage.html
 *  /na/en/governments/somepage.html
 *  etc.
 */
const initHeroAndPromoLinks = () => {
  if (knowledeArticleRe.test(location.pathname)) {
    const tab = getNavigationTabFromSection();
    const baseUrl = getBaseURL(tab.find('a').attr('href'));
    const promises = [];

    $('.hero-wrapper .btn,.contact-banner .btn').each((i, el) => {
      el = $(el);
      const link = el.get(0);
      // only site links
      if (link.hostname === location.hostname) {
        const isHeroLink = el.closest('.hero-wrapper').length;
        const page = link.pathname.split('/').pop(); // TODO: URL Ends with /
        const path = `${baseUrl}/${page}`;
        const promise = pageExists(fullUrl(path))
          .then(() => {
            el.attr('href', `${path}${link.search}`);
            if (isHeroLink) {
              el.show();
            }
          })
          .catch(() => {
            // TODO: look for generic
            // pageExists(link.href).then()
            // Assumes footer links are fine, TODO?
            if (isHeroLink) {
              el.hide();
            }
          });
        promises.push(promise);
      } else {
        el.show();
      }
    });
    Promise.all(promises).then(() => {
      $('.hero-left-content .btn:visible').removeClass('hero-cta-btn').removeClass('hero-white-cta-btn');
      $('.hero-left-content .btn:visible:even').addClass('hero-cta-btn');
      $('.hero-left-content .btn:visible:odd').addClass('hero-white-cta-btn');
    });
  } else {
    $('.hero-wrapper .btn').show();
  }
};

const initFooterCategoryLinks = () => {
  const tab = getNavigationTabFromSection();
  if (tab && tab.length) {
    const baseUrl = getBaseURL(tab.find('a').attr('href'));

    $('.cghb-global-footer a[href*="/search-results"], .backBtn').each((i, el) => {
      el = $(el);
      const link = el.get(0);
      const path = `${baseUrl}/knowledge/search-results.html`;
      pageExists(fullUrl(path)).then(el.attr('href', `${path}${link.search}`));
    });
  }
};

const initFilter = () => {
  const { pathname, search } = location;
  const params = getParams(search);
  const rls = getRegionLanguageSection(pathname);
  const { language } = rls;
  const category = params.category || capitalizeEveryWord(allLookup[language]) || 'All';
  const categorySelect = $('#category-select');
  const validCategories = Array.from(categorySelect.closest('.dropdown-update').find('.dropdown-item')).map(el => $(el).text());
  if (validCategories.includes(category)) {
    categorySelect.attr('title', category).text(category);
  }

  if ($('.single-article').length) {
    let page = parseInt(params.page || 1, 10);
    const cat = toKebabCase(category.toLowerCase());
    const uniqArticlesLength = $('.single-article').filter((i, e) => toKebabCase($(e).attr('data-category').toLowerCase()) === cat).length;
    const isAll = Object.values(allLookup).includes(cat);
    const resultCount = (isAll) ? $('.single-article').length : uniqArticlesLength;
    if (resultCount) {
      const totalPages = Math.ceil(resultCount / pageSize);
      let showIndex = 0;

      page = Math.min(page, totalPages);

      $('.single-article').each((i, el) => {
        el = $(el);
        if (isAll || toKebabCase(el.attr('data-category').toLowerCase()) === cat) {
          showIndex += 1;
          if (Math.ceil(showIndex / pageSize) === page) {
            el.show();
          }
        }
      });

      if (validCategories.includes(category)) {
        const categoryHtml = renderTemplate(categoryTemplate, { category, resultCount });
        $('.icon-list.one-column').parent().before(categoryHtml); // Kind of hackish
      }

      const paginationHtml = renderTemplate(paginationTemplate, {
        page,
        totalPages,
        resultCount,
        rangeStart: (pageSize * (page - 1)) + 1,
        rangeEnd: Math.min(pageSize * page, resultCount),
        nextUrl: `${location.pathname}?${updateQueryString({ page: page + 1 }, location)}`,
        previousUrl: `${location.pathname}?${updateQueryString({ page: page - 1 }, location)}`,
        pageLanguage
      });
      $('.icon-list.one-column').parent().append(paginationHtml); // Kind of hackish
    }
  }
};

const initSearch = () => {
  $('#knowledge-get-results').on('click', (el) => {
    el.preventDefault();
    const category = $('#category-select').text().trim();
    const url = el.currentTarget;
    const qs = updateQueryString({ category }, url);
    location.assign(`${url.href.split('?')[0]}?${qs}`);
  });
};

const initKnowledgeNav = () => {
  const isKnowledge = $('.knowledge-navigation');
  const { section } = getParams(location.search);

  if (isKnowledge && isKnowledge.length) {
    let tabToShow = isKnowledge.children().first();
    if (section && section.length) {
      if ($(`.knowledge-navigation div[data-section="${section}"]`).length) {
        tabToShow = $(`.knowledge-navigation div[data-section="${section}"]`);
      }
    }
    isKnowledge.children().hide();
    tabToShow.show();

    const currNavText = $('.middle-nav-links li a.active');
    $('.mobile-nav-text').text(currNavText.first().text());
    $('.main-nav-list a').each((i, e) => {
      if ($(e).text() === currNavText.first().text()) {
        $(e).hide();
      }
    });
  }
};

const initRelatedArticles = () => {
  const articles = $('.related-articles-holder .related-article');
  const currentArticle = $('.knowledge-article').attr('data-headline');
  if (articles && articles.length) {
    const toShow = [...articles];
    $(
      toShow
        .filter(a => $(a).attr('data-headline') !== currentArticle)
        .sort(() => Math.random() - 0.5)
        .splice(0, 3)
    ).show();
  }
};

const initBreadcrumbs = () => {
  if ($('.knowledge-article').length) {
    const tab = getNavigationTabFromSection(false);
    const tabUrl = tab.find('a').attr('href');
    const baseUrl = getBaseURL(tabUrl);

    // Translations of 'Knowledge' for different languages.
    const rootLabel = {
      en: 'Knowledge',
      es: 'Conocimientos',
      fr: 'Informations',
      de: 'Wissen',
      nl: 'Informatie'
    };

    const breadcrumbs = [{
      url: `${baseUrl}/knowledge/explore-cigna.html`,
      label: rootLabel[pageLanguage]
    }];

    const category = $('.knowledge-article').attr('data-category');
    if (category) {
      breadcrumbs.push({
        url: `${baseUrl}/knowledge/search-results.html?category=${category}`,
        label: category
      });
    } else {
      console.warn('Knowledge Article category is undefined.');
    }

    breadcrumbs.push({
      label: $('.knowledge-article').attr('data-headline')
    });

    const html = renderTemplate(breadcrumbsTemplate, { breadcrumbs });
    $('ol.breadcrumb').empty().html(html);
  }
};

const updateReadMore = ({ language } = {}) => {
  const $this = $('.readMore-knowledge');
  const lookup = {
    en: 'Read more',
    es: 'Leer más',
    fr: 'En apprendre davantage',
    de: 'Weiterlesen',
    nl: 'Lees meer'
  };

  if ($this.length === 0) return;

  $this.text(`${lookup[language] || 'Read more'} >`);
};

export default () => {
  updateReadMore(getRegionLanguageSection(location.pathname));
  selectTab();
  initKnowledgeNav();
  initHeroAndPromoLinks();
  initLinks();
  initFooterCategoryLinks();
  initFilter();
  initSearch();
  initBreadcrumbs();
  initRelatedArticles();
};



// WEBPACK FOOTER //
// ./src/static/js/knowledge.js